import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import { MenuItemType } from '#/components/layout/header/headerTypes';
import AppVersionMenuItem from '#/components/layout/header/items/AppVersionItem';
import {
  DividerHorizontalItem,
  HorizontalSpacerItem,
} from '#/components/layout/header/items/DividerItems';

import { resourcesLinks } from '../resourcesLinks';

const DownIconStyled = styled(MaterialSymbol)`
  /** Reduce right gap */
  margin-right: -6px;
  color: var(--gray4b);
`;

const HelpMenuDropdownItem: MenuItemType = {
  type: 'MenuDropdown' as const,
  label: (
    <>
      More <DownIconStyled icon="arrow_drop_down" rounded />
    </>
  ),
  items: [
    HorizontalSpacerItem,
    ...resourcesLinks.map(
      resource =>
        ({
          type: 'DropdownMenuLink',
          label: resource.label,
          to: resource.to,
        }) as MenuItemType
    ),
    DividerHorizontalItem,
    AppVersionMenuItem,
    HorizontalSpacerItem,
  ],
};

export default HelpMenuDropdownItem;
